var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationSeverityWarningCircleOrange = function SvgNotificationSeverityWarningCircleOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    d: "M10 17.708a7.708 7.708 0 1 0 0-15.416 7.708 7.708 0 0 0 0 15.416Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    d: "M10 6.458v3.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD7F38",
    d: "M10 14.167a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })));
};
export { SvgNotificationSeverityWarningCircleOrange as ReactComponent };
export default __webpack_public_path__ + "8a63120512e0af883c172d1970b82c5d.svg";